import { RootState } from "@store/rootReducer";

export const selectOrganisationContextId = (s: RootState) => s.app.organisationContextId;